export default {
  SET_CONFIG(state, data) {
    state.configList = data
  },
}
